import { combineReducers } from 'redux';
import room from './room';
import me from './me';
import producers from './producers';
import peers from './peers';
import lobbyPeers from './lobbyPeers';
import consumers from './consumers';
import peerVolumes from './peerVolumes';
import chat from './chat';
import files from './files';
import settings from './settings';
import intl from './intl';
import alert from './alert';
import sketch from './sketch';
import auth from './auth';
import rooms from './rooms';
import meetings from './meetings';
import closedCaption from './closedCaption';
import breakoutRooms from './breakoutRooms';
import app from './app';
// import { intlReducer } from 'react-intl-redux';

export default combineReducers({
	auth,
	room,
	me,
	producers,
	consumers,
	peers,
	lobbyPeers,
	peerVolumes,
	chat,
	files,
	settings,
	// intl : intlReducer
	intl,
	alert,
	rooms,
	sketch,
	meetings,
	closedCaption,
	breakoutRooms,
	app
});
